import styled, { css } from 'styled-components';

import { breakpoints, Button, theme } from '@notino/react-styleguide';

export const PickUpButtonWrapper = styled.div`
  margin-top: 0.5rem;
  flex: 0 1 100%;
  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
    flex: auto;
  }
`;

export const PickUpButton = styled(Button)<{ newDesign: boolean }>`
  width: 100%;
  ${({ newDesign }) =>
    newDesign
      ? css`
          height: 3.25rem;
          ${theme.typography.labelRegular}
        `
      : css`
          @media (min-width: ${breakpoints.sm}) {
            width: auto;
          }
        `}
`;
